var map = {
	"./about-us/feature-1.png": 96864,
	"./about-us/feature-2.png": 27369,
	"./about-us/team - Copy.png": 19837,
	"./about-us/team.png": 76457,
	"./advertisement/ad-1.png": 3444,
	"./arrow-drop.svg": 99647,
	"./avatar.svg": 73048,
	"./back.svg": 74347,
	"./bad-breathe/1.png": 79334,
	"./banner/1.png": 87076,
	"./banner/2.png": 88481,
	"./banner/3.png": 56713,
	"./banner/4.png": 88614,
	"./banner/5.png": 99986,
	"./banner/6.png": 92349,
	"./banner/7.png": 20569,
	"./banner/about-us.png": 791,
	"./blck-logo.png": 21517,
	"./blck-logo.svg": 73112,
	"./blog-1.jpeg": 3491,
	"./blogs/blog-1.png": 49247,
	"./blogs/video-thumb.png": 95249,
	"./calendar.png": 56605,
	"./car.png": 80941,
	"./discover/expert-guidance.png": 8654,
	"./discover/industry-updates.png": 26802,
	"./discover/online-prescription.png": 97272,
	"./discover/treatment-advice.png": 74414,
	"./discover/video-consultation.png": 5222,
	"./filter.svg": 37559,
	"./home_icon.svg": 51120,
	"./icon_setting.svg": 99491,
	"./icons/arrow_down.svg": 40868,
	"./icons/back_btn.svg": 91032,
	"./icons/close.svg": 34241,
	"./icons/expand_right.svg": 64374,
	"./icons/play_button.png": 93260,
	"./icons/right_arrow.svg": 7024,
	"./image_placehodler.png": 54114,
	"./img-1.jpg": 60904,
	"./img-2.jpg": 88320,
	"./img-3.jpg": 45713,
	"./img-4.jpeg": 54877,
	"./lg_video_frame.png": 27889,
	"./line.png": 20526,
	"./live_chat.png": 88981,
	"./loader.gif": 31298,
	"./login-bg.png": 40933,
	"./logo-1.svg": 70282,
	"./logo-light.svg": 1066,
	"./logo-short.png": 77176,
	"./logo.png": 74427,
	"./logo.svg": 82835,
	"./logo_side.svg": 22590,
	"./logo_white.svg": 66784,
	"./logos/bbc-logo.png": 20741,
	"./logos/cosmopolitan.png": 89265,
	"./logos/daily-mail.png": 10444,
	"./logos/guardian-logo.png": 62001,
	"./maximize_icon.png": 61746,
	"./menu.svg": 28647,
	"./message_icon.svg": 76028,
	"./newImages/10.jpg": 13367,
	"./newImages/14.jpg": 67726,
	"./newImages/18.jpg": 59922,
	"./newImages/Abs.jpg": 76015,
	"./newImages/Cavity.jpg": 79206,
	"./newImages/CrackedTooth.jpg": 74375,
	"./newImages/DentalPain.jpg": 46000,
	"./newImages/DrySocket - Copy.jpg": 13668,
	"./newImages/DrySocket.jpg": 54709,
	"./newImages/ExpertGuidance.jpg": 43996,
	"./newImages/Headaches.jpg": 82328,
	"./newImages/IndustryUpdates.jpg": 48546,
	"./newImages/JawAche.jpg": 59687,
	"./newImages/MouthUlcers.jpg": 97405,
	"./newImages/OnlinePrescriptions.jpg": 16073,
	"./newImages/Perico.jpg": 80528,
	"./newImages/PostOpJawAche.jpg": 95580,
	"./newImages/Pulpitis.jpeg": 12031,
	"./newImages/ReversiblePulpitis.jpg": 71949,
	"./newImages/TMD.jpg": 66157,
	"./newImages/TreatmentsAdvice.jpg": 83831,
	"./newImages/Ulcers.jpg": 3366,
	"./newImages/VideoConsultation.jpg": 36845,
	"./newImages/dentist.jpg": 65874,
	"./newImages/reputation.jpg": 56283,
	"./pay-form.png": 19946,
	"./phone.svg": 25244,
	"./place-holder-user.png": 34284,
	"./plus_sign.png": 96878,
	"./prevention-education/1.png": 84167,
	"./prevention-education/cavity_new.jpeg": 57019,
	"./prevention-education/cavity_new.jpg": 9633,
	"./prevention-education/teeth.jpg": 17792,
	"./prevention-education/teeth_diag.jpg": 48657,
	"./prevention-education/teeth_prblm-2.jpg": 53911,
	"./prevention-education/teeth_prblm_img.jpg": 18120,
	"./prevention-education/tooth_prblm_4.jpg": 4583,
	"./prevention-education/tooth_prblm_4_new.jpg": 29909,
	"./prevention-education/tooth_prblm_5.jpg": 75316,
	"./prevention-education/tooth_prblm_6.jpg": 74293,
	"./prevention-education/tooth_prblm_7.jpg": 56738,
	"./prevention-education/tooth_prblm_8.jpg": 91766,
	"./prevention-education/tooth_prblm_9.jpg": 80534,
	"./problems/abcesses.png": 40411,
	"./problems/bleeding-gums.png": 7710,
	"./problems/cracked-tooth.png": 3915,
	"./problems/dent-issue.png": 85425,
	"./problems/filling-issue.png": 95883,
	"./problems/imp-issues.png": 40343,
	"./problems/swelling.png": 3357,
	"./problems/tooth-ache.png": 20988,
	"./problems/ulcer_new.jpg": 91809,
	"./problems/ulcers.png": 78239,
	"./report/bodywork.svg": 97900,
	"./report/brakes.svg": 93002,
	"./report/interior.svg": 58624,
	"./report/keys.svg": 91717,
	"./report/lights.svg": 32619,
	"./report/mechanical.svg": 72366,
	"./report/service.svg": 79402,
	"./report/tyres.svg": 55930,
	"./report/wheel.svg": 57031,
	"./select-drop-td.svg": 5581,
	"./select.svg": 74579,
	"./setting.png": 59367,
	"./sidebar_icons/Folder_search_duotone_white.svg": 38353,
	"./sidebar_icons/circle-blue.svg": 78179,
	"./sidebar_icons/date_drk.svg": 33029,
	"./sidebar_icons/date_today_duotone.svg": 39383,
	"./sidebar_icons/file_dock_add_fill.svg": 92987,
	"./sidebar_icons/folder_search_duotone.svg": 33260,
	"./sidebar_icons/home_duotone.svg": 46169,
	"./sidebar_icons/home_white.svg": 27034,
	"./sidebar_icons/prescription-white.svg": 47960,
	"./sidebar_icons/temperature.svg": 31134,
	"./sidebar_icons/temperature_white.svg": 52539,
	"./sidebar_icons/user_cicrle_duotone.svg": 21747,
	"./small_video_frame.png": 29735,
	"./submit_register.jpg": 6214,
	"./testimonial/1-lg.png": 34160,
	"./testimonial/1.png": 23994,
	"./testimonial/2-lg.png": 66551,
	"./testimonial/2.png": 32331,
	"./testimonial/3-lg.png": 55519,
	"./testimonial/3.png": 5227,
	"./testimonial/4-lg.png": 18051,
	"./testimonial/4.png": 4626,
	"./testimonial/5-lg.png": 74272,
	"./testimonial/5.png": 3382,
	"./testimonial/6-lg.png": 36986,
	"./testimonial/6.png": 85515,
	"./testimonial/7-lg.png": 61363,
	"./treatment/1.png": 63417,
	"./users.png": 92721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;